<script>
import {
    mapGetters
} from 'vuex';
export default {
    name: 'CompetenceCardsDataProvider',
    computed: {
		...mapGetters('competences', {
			competenceCards: 'competenceCards',
			competenceCardRows: 'competenceCardRows',
			batchCompetenceCardRows: 'batchCompetenceCardRows',
			loading: 'loading',
		}),
		
		anyCompetenceCards() {
			return (!this.loading && this.competenceCards.length > 0);
		}
	},
	methods: {

	},
    render() {
        if (!this.$scopedSlots.default) {
            return;
        }

        const slotScope = {
			loading: this.loading,
			competenceCardRows: this.competenceCardRows,
			batchCompetenceCardRows: this.batchCompetenceCardRows,
			anyCompetenceCards: this.anyCompetenceCards
		};
		
        return this.$scopedSlots.default(slotScope);
    },
    created() {
		if(!this.competenceCards || this.competenceCards.length === 0) {
			this.$store.dispatch('competences/fetchCompetenceCards');
		}
	}
}
</script>
